import styled, { css } from 'styled-components';
/**
 * FormFieldPasswordIcon
 */
export const FormFieldPasswordIconStyles = ({ theme, $colorContext, }) => css `
	padding: 0;
	background-color: transparent;
	border: none;
	border-radius: 0;
	cursor: pointer;
	color: ${theme.colors.highlight.iconInteractive};

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.iconHover};
	}

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.blanc.iconInteractiveInverse};

		&:focus {
			color: ${theme.colors.blanc.iconInteractiveInverse};
		}

		&:hover {
			color: ${theme.colors.medium.iconInverseHover};
		}
	`}

	/* Remove margin set by form-container-field.styled.ts on all button elements  */
	&& {
		margin-left: 0;
	}
`;
export const FormFieldPasswordIcon = styled.button `
	${FormFieldPasswordIconStyles}
`;
